import { render } from "./FullVideoComponent.vue?vue&type=template&id=74a3fb90"
import script from "./FullVideoComponent.vue?vue&type=script&lang=ts"
export * from "./FullVideoComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script